import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import WarehouseQuoteStorageForm from './forms/WareHouseStorageForms/WareHouseStorageForm';
import { QuoteDataForm } from '../../../../../app/models/Quote';
import WarehouseQuoteRateForm from './forms/WareHouseRatesForms/WareHouseRatesForm';
import useWarehouseQuoteRatesService from '../../../../../app/services/hooks/useWareHouseQuoteRateService';
import { defaultWarehouseQuoteRateDataForm, WarehouseQuoteRateDataForm } from '../../../../../app/models/WareHouseQuoteRates';
import { Currency } from '../../../../../app/models/Currency';
import { Depot } from '../../../../../app/models/Depot';
import { Product } from '../../../../../app/models/Product';
import { Unit } from '../../../../../app/models/Unit';
import { AppContext } from '../../../../../contexts/AppContext';

interface Props {
    rateId: number
    
    onSaved: () => void;
    onCancel: () => void;
}

const WarehouseQuoteRateEdit = ({ rateId,onSaved, onCancel }: Props) => {
    const { updateWarehouseQuoteRate, editWarehouseQuoteRate } = useWarehouseQuoteRatesService();
    const [warehouseRateform, setwarehouseRateform] = useState<WarehouseQuoteRateDataForm>({...defaultWarehouseQuoteRateDataForm});

    const [depots, setDepots] = useState<Depot[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    useEffect(() => {
        edit();
    }, [rateId]);


    const edit = () => {
        editWarehouseQuoteRate(rateId, {
            onSuccess: (response: ServiceResponse) => {
                const data = response.data.warehouse_quote_rate;
                setwarehouseRateform( {...data});
                setDepots(response.data.depots);
                setProducts(response.data.products);
                setCurrencies(response.data.currencies);
                setUnits(response.data.units);
            },
            onError: (response: ServiceResponse) => {
                toast.error('Error al cargar almacenamiento');
            }
        });
    };




    const update = () => {
        updateWarehouseQuoteRate(rateId, warehouseRateform, {
            onSuccess: (response: ServiceResponse) => {
                toast.success(response.message);
                onSaved();
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            },
            onFieldError: (response: ServiceResponse) => {
                // Manejo de errores por campo si es necesario
            }
        });
    };

    return (
        <>
            <WarehouseQuoteRateForm
                rateForm={warehouseRateform}
                setRateForm={setwarehouseRateform}
                depots={depots}
                products={products} 
                currencies={currencies}
                units={units}
                disableUpdate={false}
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} />
                </div>
            </div>
        </>
    );
};

export default WarehouseQuoteRateEdit;
